export const getSelectOptionsClasses = ({ noPadding, selected }: { noPadding?: boolean; selected: boolean }) =>
  `relative cursor-pointer select-none ${noPadding ? '' : 'py-2 pl-10 pr-4'} ${
    selected ? 'bg-teal-600 text-white' : 'text-gray-900'
  } hover:bg-teal-400 hover:text-white`;
